import { useLocation, useNavigate } from 'react-router-dom';
import { ClipboardCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { shouldShowProfileReminder } from '../lib/onboarding';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';

export const ProfileCompletionReminder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    profileStatus,
    profileStatusLoading,
    profileReminderDismissed,
    dismissProfileReminder,
  } = useAuth();
  const open = shouldShowProfileReminder({
    status: profileStatus,
    loading: profileStatusLoading,
    dismissed: profileReminderDismissed,
    onProfilePage: location.pathname === '/account/profile',
  });

  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="profile-completion-reminder-dialog">
        <AlertDialogHeader>
          <div className="mb-2 grid h-10 w-10 place-items-center rounded-md bg-accent text-accent-foreground">
            <ClipboardCheck className="h-5 w-5" />
          </div>
          <AlertDialogTitle data-testid="profile-completion-reminder-title">
            Complete your AHA profile
          </AlertDialogTitle>
          <AlertDialogDescription data-testid="profile-completion-reminder-description">
            Add your contact details and accept the current Terms and Privacy Notice. You can do this now or continue using your existing projects and complete it later from Account/Profile.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={dismissProfileReminder} data-testid="profile-completion-later-button">
            Later
          </AlertDialogCancel>
          <AlertDialogAction onClick={() => navigate('/account/profile')} data-testid="profile-completion-open-button">
            Complete profile
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};